import { createApp } from 'vue'
import DitRaaderumCalculator from './DitRaaderumCalculator.vue'
import handleComponentProps from '../../foundation/js/utils/handleComponentProps.js'

const elementSelector = '.nyk-component--dit-raaderum-calculator'

export default function (Store) {
    document.querySelectorAll(elementSelector).forEach((element) => {
        const props = handleComponentProps(DitRaaderumCalculator, element)
        createApp(DitRaaderumCalculator, props).use(Store).mount(element)
    })
}